import { useState } from 'react';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  FloatingActionsMenu,
  LineageGraph,
} from '@elementary/common-ui/components';
import useSelectedTreeItem from '@elementary/common-ui/hooks/useSelectedTreeItem';
import { isInSaaSMode } from '@elementary/common-ui/utils/common';
import { useBreadcrumbs } from '@elementary/common-ui/hooks/useBreadcrumbs';
import type { DagDepthBoundary } from '@elementary/common-ui/components/lineageGraph/types';
import useReport from '@/shared/hooks/useReport';
import LineageFilters from './LineageFilters';

const BreadcrumbsContainer = styled(Flex)`
  position: absolute;
  top: 24px;
  left: 24px;
  background: ${({ theme }) => theme.palette.common.white};
  border: ${({ theme }) => `1px solid ${theme.palette.common.gray13}`};
  border-radius: 8px;
  z-index: 1;
  padding: 8px;
  padding-right: 14px;
`;

const Lineage = () => {
  const { selectedTreeNode, selectedModelColumn } = useSelectedTreeItem();
  const { reportData } = useReport();

  const breadcrumbs = useBreadcrumbs({
    pageTitle: 'Lineage',
  });

  const [dagDepthBoundary, setDagDepthBoundary] = useState<DagDepthBoundary>();

  const showFilters = selectedTreeNode || selectedModelColumn;

  return (
    <FlexColumn
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BreadcrumbsContainer>
        <Breadcrumbs items={breadcrumbs} />
      </BreadcrumbsContainer>

      <LineageFilters
        hidden={!showFilters}
        dagDepthBoundary={dagDepthBoundary}
      />
      <LineageGraph
        reportData={reportData}
        onDagDepthBoundaryChange={setDagDepthBoundary}
      />
      {isInSaaSMode() && <FloatingActionsMenu />}
    </FlexColumn>
  );
};

export default Lineage;
